import React from 'react';
import { useState } from 'react';
import { useParams } from 'react-router';
import { SharedAccessAuthForm } from 'apps/sigma2-ui/src/components/auth/SharedAccessAuthForm';
import { EmbedDashboardPage } from 'apps/sigma2-ui/src/pages/Dashboards/EmbedDashboardPage';
import { PublicLayout } from 'apps/sigma2-ui/src/components/PublicLayout';

export const SharedAccessDashboardPage = () => {
  const { dashboardId } = useParams();
  const [verified, setVerified] = useState(false);

  if (!dashboardId) return null;

  if (!verified) {
    return (
      <PublicLayout>
        <SharedAccessAuthForm
          resourceId={dashboardId}
          resourceType="dashboard"
          onVerified={() => setVerified(true)}
        />
      </PublicLayout>
    );
  }

  return <EmbedDashboardPage />;
};
